import getConfig from 'next/config';

import { safeDifferenceInCalendarDays } from 'shared/util/datetime-fns';
import { filtersToResultPageBrowserQueryParams } from '@/utils/url/resultPageQueryParams';
import { extractNameFromKey } from '@/utils/kayakKeys';
import useAppSelector from '@/hooks/useAppSelector';

const { publicRuntimeConfig } = getConfig();

interface Props {
    checkInDate?: Date | number;
    checkOutDate?: Date | number;
    filtersSelected?: boolean;
}

const helpTextDesktop = (filtersSelected: boolean, checkInDate?: Date | number, checkOutDate?: Date | number): string => {
    if (checkInDate && checkOutDate && filtersSelected) {
        return 'Hvis du velger bort et eller flere filtere, endrer dato eller antall personer kan vi finne tilgjengelige tilbud til deg';
    }
    return checkInDate && checkOutDate
        ? 'Hvis du endrer dato eller antall personer kan vi finne tilgjengelige tilbud til deg'
        : 'Hvis du velger dato kan vi finne tilgjengelige tilbud til deg';
};

const helpTextMobile = (filtersSelected: boolean, checkInDate?: Date | number, checkOutDate?: Date | number): string => {
    if (checkInDate && checkOutDate && filtersSelected) {
        return (
            'Hvis du velger bort et eller flere filtere, endrer dato eller antall personer ' +
            'ved å klikke på blyanten over kan vi finne tilgjengelige tilbud til deg'
        );
    }
    return checkInDate && checkOutDate
        ? 'Hvis du endrer dato eller antall personer ved å klikke på blyanten over kan vi finne tilgjengelige tilbud til deg'
        : 'Hvis du velger dato ved å klikke på blyanten over kan vi finne tilgjengelige tilbud til deg';
};

export const NoOffersWarning = ({ checkInDate, checkOutDate, filtersSelected = false }: Props) => {
    const filters = useAppSelector((state) => state.filters);
    const place = useAppSelector((state) => state.hotelPage.place);
    const placeKey = extractNameFromKey(place?.key);

    const header =
        checkInDate && checkOutDate
            ? 'Vi fant dessverre ingen tilgjengelige overnattingstilbud'
            : 'For å finne overnattingstilbud må du først velge dato';

    const errorText =
        checkInDate && checkOutDate && safeDifferenceInCalendarDays(checkInDate, checkOutDate) > 30
            ? 'For å finne overnattingstilbud må oppholdet vare maks 30 netter'
            : undefined;

    return (
        <div className="u-text-center u-mv32" data-testid="emptyWarning">
            <p data-testid="header" className="u-t2 u-mb16">
                {header}
            </p>

            {errorText ? (
                <p className="u-cherry" data-testid="errorText">
                    {errorText}
                </p>
            ) : (
                <p data-testid="helpText">
                    <span className="u-hide-gt768">{helpTextMobile(filtersSelected, checkInDate, checkOutDate)}, eller du kan </span>
                    <span className="u-hide-lt768">{helpTextDesktop(filtersSelected, checkInDate, checkOutDate)}, eller du kan </span>
                    <a
                        href={`${publicRuntimeConfig.basePath}/resultat/${placeKey}/?${filtersToResultPageBrowserQueryParams(
                            filters,
                            false,
                        )}`}>
                        se på andre overnattingssteder i samme område
                    </a>
                </p>
            )}
        </div>
    );
};
